import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api/axios.config';
import { notify } from '../utils/methods/notification';

const initialState = {
    isLoading: false,
    allDeliveryPartners: [],
    addModal: false
};

// fetch all Delivery Partners
export const fetchAllDeliveryPartners = createAsyncThunk(
    'bmr/fetchAllDeliveryPartners',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get('/delivery_partners');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// add Delivery Partner
export const addDeliveryPartner = createAsyncThunk(
    'bmr/addDeliveryPartner',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.post('/delivery_partners/create', args);
            notify.success(response.data.message);
            dispatch(disableAddModal());
            dispatch(fetchAllDeliveryPartners());
            return response.data;
        } catch (error) {
            notify.error(error || error.message);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// edit Delivery Partner
export const editDeliveryPartner = createAsyncThunk(
    'bmr/editDeliveryPartner',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { data, editId } = args;
            const response = await api.put(`/delivery_partners/update/${editId}`, data);
            notify.success(response.data.message);
            dispatch(disableAddModal());
            dispatch(fetchAllDeliveryPartners());
            return response.data;
        } catch (error) {
            notify.error(error?.message || error);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// delete Delivery Partner
export const deleteDeliveryPartner = createAsyncThunk(
    'bmr/deleteDeliveryPartner',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { id } = args;
            const response = await api.delete(`/delivery_partners/${id}`);
            notify.success(response.data.message);
            dispatch(fetchAllDeliveryPartners());
            return response.data;
        } catch (error) {
            notify.error(error?.message || error);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

const bmrDeliveryPartnersSlice = createSlice({
    name: 'bmrDeliveryPartners',
    initialState,
    reducers: {
        enableAddModal(state) {
            state.addModal = true;
        },
        disableAddModal(state) {
            state.addModal = false;
        },
    },
    extraReducers: (builder) => {
        builder
            // fetch
            .addCase(fetchAllDeliveryPartners.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAllDeliveryPartners.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allDeliveryPartners = action.payload.data;
            })
            .addCase(fetchAllDeliveryPartners.rejected, (state) => {
                state.isLoading = false;
            })
            // add
            .addCase(addDeliveryPartner.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(addDeliveryPartner.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(addDeliveryPartner.rejected, (state) => {
                state.isLoading = false;
            })
            // edit
            .addCase(editDeliveryPartner.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(editDeliveryPartner.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(editDeliveryPartner.rejected, (state) => {
                state.isLoading = false;
            })
            // delete
            .addCase(deleteDeliveryPartner.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteDeliveryPartner.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(deleteDeliveryPartner.rejected, (state) => {
                state.isLoading = false;
            });
    },
});

export const { disableAddModal, enableAddModal } = bmrDeliveryPartnersSlice.actions;

export const selectDeliveryPartnersLoading = (state) => state.bmrDeliveryPartners.isLoading;
export const selectDeliveryPartnersAll = (state) => state.bmrDeliveryPartners.allDeliveryPartners;
export const selectBmrAddDeliveryPartnerModal = (state) => state.bmrDeliveryPartners.addModal;

export default bmrDeliveryPartnersSlice.reducer;